import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c48bd4d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lightingText" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "glowing" }, "Light"),
  /*#__PURE__*/_createElementVNode("label", { class: "under" }, "it up")
], -1))
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lightingParagraph" }, " Set the mood through our lighting interface using Lumishore, ShadowCaster, or our own LiteWave system. ", -1))
const _hoisted_4 = { class: "lightingSpinner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"position":"relative","width":"60%"} }, null, -1))
const _hoisted_6 = { class: "lightingImg" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  id: "Layer_2",
  "data-name": "Layer 2",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 680.26 680.26"
}, [
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("filter", {
      id: "drop-shadow-1",
      filterUnits: "userSpaceOnUse"
    }, [
      /*#__PURE__*/_createElementVNode("feOffset", {
        dx: "4.98",
        dy: "4.98"
      }),
      /*#__PURE__*/_createElementVNode("feGaussianBlur", {
        result: "blur",
        stdDeviation: "6.23"
      }),
      /*#__PURE__*/_createElementVNode("feFlood", {
        "flood-color": "#000",
        "flood-opacity": ".75"
      }),
      /*#__PURE__*/_createElementVNode("feComposite", {
        in2: "blur",
        operator: "in"
      }),
      /*#__PURE__*/_createElementVNode("feComposite", { in: "SourceGraphic" })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, [
    /*#__PURE__*/_createElementVNode("g", { id: "dialRotate" }, [
      /*#__PURE__*/_createElementVNode("circle", {
        id: "dial",
        class: "cls-3",
        cx: "651.79",
        cy: "340.13",
        r: "27.84"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        id: "container",
        class: "cls-1",
        cx: "340.13",
        cy: "340.13",
        r: "339.45"
      })
    ]),
    /*#__PURE__*/_createElementVNode("circle", {
      id: "colorFade",
      class: "cls-2",
      cx: "340.13",
      cy: "340.13",
      r: "102.49"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "lightingContainer",
    style: _normalizeStyle({'--highlightColor': $data.highlightColor, '--rotate': $data.currentRotate + 'deg'})
  }, [
    _hoisted_1,
    _createElementVNode("img", {
      class: "lightingLogos",
      src: require('@/assets/lightingLogos.png')
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: require('@/assets/lightingBackground.png')
        }, null, 8, _hoisted_7),
        _hoisted_8
      ])
    ])
  ], 4))
}